(function () {
  var root = document.querySelector("[data-uf-blog-article]");
  if (!root) return;

  var header =
    document.querySelector(".site-header") ||
    document.querySelector(".header") ||
    document.querySelector("header[role='banner']");

  function setHeaderOffset() {
    var h = header ? header.offsetHeight : 0;
    if (h < 48) h = 72;
    root.style.setProperty("--uf-bh-header-offset", h + "px");
  }

  setHeaderOffset();

  if (typeof ResizeObserver !== "undefined" && header) {
    var ro = new ResizeObserver(setHeaderOffset);
    ro.observe(header);
  }

  window.addEventListener("resize", setHeaderOffset, { passive: true });
  window.addEventListener("orientationchange", setHeaderOffset, { passive: true });
  document.addEventListener("shopify:section:load", setHeaderOffset);
})();
